import React from "react";
import Text from "../../../../../shared/components/Text";
import { formatMoneyNum, formatPercent } from "nemuru-components";
import { SummaryConditionsRow } from "../../shared/components/SummaryConditionsRow";

export const CreditLineWithPurchaseConditions = ({ loanConditions }) => {
  const {
    period,
    principalAmount,
    tin,
    tae,
    totalAmountToPay,
    setupFee,
    gracePeriod,
    assetAmount,
  } = loanConditions;

  return (
    <>
      <SummaryConditionsRow
        title={<Text tId="LOAN_DURATION" />}
        value={<Text tId={"X_MONTHS"} dynamicDataTexts={period} />}
      />
      <SummaryConditionsRow
        title={<Text tId="CREDIT_LINE_TOTAL" />}
        value={<>{formatMoneyNum(assetAmount)} €</>}
      />
      <SummaryConditionsRow
        title={<Text tId="LOAN_TOTAL" />}
        value={<>{formatMoneyNum(principalAmount)} €</>}
      />
      <SummaryConditionsRow
        title={<Text tId="TIN" />}
        value={<>{formatPercent(tin)}</>}
      />
      <SummaryConditionsRow
        title={<Text tId="TAE" />}
        value={<>{formatPercent(tae)}</>}
      />
      <SummaryConditionsRow
        title={<Text tId="TOTAL_TO_PAY" />}
        value={<>{formatMoneyNum(totalAmountToPay)} €</>}
      />
      <SummaryConditionsRow
        title={<Text tId="SETUP_FEE" />}
        value={<>{formatMoneyNum(setupFee)} €</>}
      />
      {gracePeriod > 0 && (
        <SummaryConditionsRow
          title={<Text tId="GRACE_PERIOD" />}
          value={<Text tId={"X_MONTHS"} dynamicDataTexts={gracePeriod} />}
        />
      )}
    </>
  );
};
